
import { getMainAppDomain } from '../../utils/base-url';
import { Cookies } from '../cookies';

const STORAGE_KEY = {
  CURRENT_COMPANY_ID: 'currentCompanyId',
} as const;

export class UserCurrentCompany {
  /**
   * 
   * @param companyId Id of current user company
   */
  static setCompany(companyId: number | string) {
    window.localStorage.setItem(STORAGE_KEY.CURRENT_COMPANY_ID, companyId.toString());
  }

  static setCompanyFromCookies() {
    const currentCompanyId = Cookies.get(STORAGE_KEY.CURRENT_COMPANY_ID);
    if (currentCompanyId) {
      this.setCompany(currentCompanyId);
      Cookies.remove(STORAGE_KEY.CURRENT_COMPANY_ID, { domain: getMainAppDomain() });
    }
  }

  static setCompanyToCookies(companyId: number) {
    Cookies.set(STORAGE_KEY.CURRENT_COMPANY_ID, companyId.toString(), { domain: getMainAppDomain() });
  }

  static removeCompanyFromCookies() {
    Cookies.remove(STORAGE_KEY.CURRENT_COMPANY_ID, { domain: getMainAppDomain() });
  }
  
  static getCompany() {
    const companyId = window.localStorage.getItem(STORAGE_KEY.CURRENT_COMPANY_ID);

    if (!companyId) return null;

    return Number.parseInt(companyId, 10) || null;
  }

  static clearCompany() {
    window.localStorage.removeItem(STORAGE_KEY.CURRENT_COMPANY_ID);
  }
}